import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // Iter49 (Shikha 23-Jun-2026) — `bg-transparent` + dark `--input` token
        // rendered the field borders & background invisible in dark mode.
        // Lock a subtle slate-900 fill and a visible slate-700 border in dark
        // mode so every input is clearly delineated against the dialog.
        "flex h-9 w-full rounded-lg border border-input bg-transparent dark:bg-slate-900/60 dark:border-slate-600 dark:text-slate-100 dark:placeholder:text-slate-500 px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
